module.exports = __webpack_public_path__ + "img/icon-white-8.24846c18.svg";